import { CssQuestionType } from '@webapp/common/components/survey-custom';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';

import { MatrixLayout } from '../matrix-layout';

import { GroupSelect } from './group-select';

export const MatrixSelect: VFC<SurveyQuestion> = ({ question }) => (
    <MatrixLayout cell={GroupSelect} className={CssQuestionType.MATRIX_LIST_SELECT} question={question} />
);
MatrixSelect.displayName = 'MatrixListSelect';
